import { useRef, useState } from 'preact/hooks'
import {
  getDefaultShowFields,
  getFieldDomByCode,
  getFreshCurrentlyDisplayFieldsByTriggeredFields,
} from 'components/business/SurveyForm/Fields/utils'
import { Field } from 'scripts/type'
import { useEffect } from 'preact/compat'
import { SDK_MODAL_TRANSITION_DURATION } from 'scripts/constants'

export default function useCurrentlyDisplayFieldsRelation(fields: Field[]) {
  const [currentlyDisplayFieldsRelationArr, setCurrentlyDisplayFieldsRelationArr] = useState(
    getDefaultShowFields(fields)
  )
  const [willHiddenFieldCodes, setWillHiddenFieldCodes] = useState<string[]>([])
  const lastFieldsRef = useRef(currentlyDisplayFieldsRelationArr)
  const hiddenFieldTimerRef = useRef<NodeJS.Timeout>()

  useEffect(() => {
    setCurrentlyDisplayFieldsRelationArr(getDefaultShowFields(fields))
  }, [fields])

  const update = (targetCode: string, triggeredFields: Field[]) => {
    const freshFields = getFreshCurrentlyDisplayFieldsByTriggeredFields(
      lastFieldsRef.current,
      targetCode,
      triggeredFields
    )
    setCurrentlyDisplayFieldsRelationArr(freshFields)
    lastFieldsRef.current = freshFields
  }

  return {
    currentlyDisplayFieldsRelationArr,
    updateCurrentlyDisplayFieldsRelationArr: update,
    willHiddenFieldCodes,
  }
}
